import { OP_SEARCH_ITEMS } from '@doda/common/src/constants/searchItems';
import { findJobCount } from 'components/IndustryModal/logics/createIndustryDisplayData';
import { LanguageSkillListType } from 'types/kodawari';
import { HooksArgument } from 'components/SearchSideBar/types';
import { LANGUAGE_SKILL_CODE_AND_QUERY } from 'constants/searchCondition';
import { getInitialIdList } from '../getInitialIdList';

/**
 * 言語の初期状態を生成
 * @param param.savedSearchCondition 保存した検索条件のレスポンス
 * @param param.featuredSearchCondition 特集枠検索条件のレスポンス
 * @param param.queries クエリパラメータ
 * @param param.jobCountData 求人件数
 * @returns 言語の初期配列を生成
 */
export const createInitialLanguageSkillList = ({
  savedSearchCondition,
  featuredSearchCondition,
  queries,
  jobCountData,
}: HooksArgument) => {
  const paramList = getInitialIdList({
    savedSearchCondition,
    featuredSearchCondition,
    queries,
  });

  const initialData: LanguageSkillListType[] = [
    {
      id: OP_SEARCH_ITEMS.english.id,
      name: OP_SEARCH_ITEMS.english.name,
      isChecked: paramList.some(
        (query) => query === OP_SEARCH_ITEMS.english.id
      ),
      value: LANGUAGE_SKILL_CODE_AND_QUERY.ENGLISH.code,
      jobCount: findJobCount(
        jobCountData.languageSkillsList,
        LANGUAGE_SKILL_CODE_AND_QUERY.ENGLISH.code
      ),
    },
    {
      id: OP_SEARCH_ITEMS.chinese.id,
      name: OP_SEARCH_ITEMS.chinese.name,
      isChecked: paramList.some(
        (query) => query === OP_SEARCH_ITEMS.chinese.id
      ),
      value: LANGUAGE_SKILL_CODE_AND_QUERY.CHINESE.code,
      jobCount: findJobCount(
        jobCountData.languageSkillsList,
        LANGUAGE_SKILL_CODE_AND_QUERY.CHINESE.code
      ),
    },
  ];

  return initialData;
};
